export function appendAkamaiHeaders<T>(headers: T) {
	if (process.env.AKAMAI_APP_ID && process.env.AKAMAI_APP_NAME) {
		headers['app-id'] = process.env.AKAMAI_APP_ID;
		headers['app-name'] = process.env.AKAMAI_APP_NAME;
	}
	return headers;
}
